import {
  Button,
  designTokens,
  Divider,
  FormControl,
  FormControlText,
  Input,
  Panel,
  PanelBody,
  PanelHeader,
  TextLink
} from '@itandi/itandi-bb-ui';
import type { FC } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { vendorCompanyLoginSchema } from '~/models/VendorCompany';
import { create as requestPasswordReset } from '~/utils/api/vendors/VendorCompanyPasswordReset';
import { isSuccess } from '~/utils/api/api_handler';

export type VendorPasswordResetPanelProps = {
  onResetMailSend: () => void;
};

export const VendorPasswordResetPanel: FC<VendorPasswordResetPanelProps> = ({
  onResetMailSend
}) => {
  const [hasSentResetMail, setHasSentResetMail] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm<{ email: string }>({
    resolver: yupResolver(vendorCompanyLoginSchema.pick(['email'])),
    mode: 'onSubmit',
    defaultValues: { email: '' }
  });

  const onSubmit = handleSubmit(async (values: { email: string }) => {
    const result = await requestPasswordReset(values.email);
    if (isSuccess(result)) {
      setHasSentResetMail(true);
      toast.success('パスワード再設定用のメールを送信しました。');
    } else {
      toast.error(result.message);
    }
  });

  return (
    <Panel>
      <PanelHeader title="パスワード再設定" />
      <PanelBody>
        <form noValidate onSubmit={onSubmit}>
          <FormControl
            isInvalid={!!errors.email}
            label="メールアドレス（ログインID）"
            variant="vertical"
          >
            <Input
              {...register('email')}
              autoComplete="username"
              placeholder="例）sample@example.com"
              type="email"
            />
            <FormControlText error={errors.email?.message} />
          </FormControl>
          <Button
            disabled={hasSentResetMail}
            loading={isSubmitting}
            marginY={designTokens['spacing/m']}
            type="submit"
            variant="primary"
            width="fill"
          >
            送信
          </Button>
        </form>
        <Divider marginY={designTokens['spacing/m']} />
        <TextLink
          color="link"
          onClick={() => {
            setHasSentResetMail(false);
            onResetMailSend();
          }}
        >
          ログイン画面に戻る
        </TextLink>
      </PanelBody>
    </Panel>
  );
};
